<template>
    <index v-bind="options"></index>
</template>

<script>

    import Index from '../../layouts/Index';

    export default {
        components: {
            Index
        },
        data() {
            return {
                options: {
                    label: 'Computers',
                }
            }
        },
    }
</script>
